import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import PrintQueueMaintenanceCont from "presentation/view/container/PrintQueue/PrintQueueContMain";

CommonEntrypoint(<PrintQueueMaintenanceCont/>)